module.exports = __webpack_public_path__ + "img/black-warning.a4125e32.svg";